import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=ced252bc&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"
import style0 from "./HeroSlider.vue?vue&type=style&index=0&id=ced252bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced252bc",
  null
  
)

export default component.exports